import { z } from 'zod';
import {
  BookingOptionDto,
  BookingSelectedOptionDto,
} from '@/features/public/booking/types/BookingOptionDto.ts';

export type SelectedOptionEntry = {
  selections?: BookingSelectedOptionDto[];
  optionDto: BookingOptionDto;
};

export const participantTourOptionsSchema = z
  .record(
    z.string(),
    z
      .object({
        selections: z
          .array(
            z.object({
              variantId: z.string(),
              priceId: z.string(),
            }),
          )
          .optional(),
        optionDto: z.any(),
      })
      .optional(),
  )
  .optional()
  .superRefine((data, ctx) => {
    for (const [optionId, entry] of Object.entries(data ?? {})) {
      const optionDto = entry?.optionDto;
      if (!optionDto) continue; // If there's no optionDto, we can't validate required
      if (!optionDto.required) continue; // If the option is not required, skip validation

      const values = entry?.selections;
      if (!values || values.length === 0) {
        ctx.addIssue({
          code: 'custom',
          message: 'Wybór tej opcji jest obowiązkowy',
          // Ścieżka musi trafić w zarejestrowane pole (`…selections`), bo
          // inaczej react-hook-form nie ma czego wyczyścić po wyborze wariantu
          // i komunikat zostaje na ekranie mimo poprawnej odpowiedzi.
          path: [optionId, 'selections'],
        });
      }
    }
  });
